import { createSlice } from "@reduxjs/toolkit";

import { getAppVersionAction, postAppVersionAction } from "./action";
import { AppVersionType } from "./appVersionType";
import { initialState } from "./initialState";
import { appVersionReducer } from "./reducer";

export const appVersionSlice = createSlice({
  name: "appVersion",
  initialState,
  reducers: appVersionReducer,
  extraReducers: (builder) => {
    builder.addCase(postAppVersionAction.pending, (state: AppVersionType) => {
      state.fetching = true;
    });
    builder.addCase(
      postAppVersionAction.fulfilled,
      (state: AppVersionType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success == 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          message,
          success,
        };
      }
    );
    builder.addCase(
      postAppVersionAction.rejected,
      (state: AppVersionType, { error }) => {
        return {
          ...state,
          fetching: false,
          error: error.message ?? null,
        };
      }
    );
    builder.addCase(getAppVersionAction.pending, (state: AppVersionType) => {
      state.fetching = true;
    });
    builder.addCase(
      getAppVersionAction.fulfilled,
      (state: AppVersionType, { payload }) => {
        const { success, message, status_code, result } = payload;
        if (success == 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          versionNumber: result?.version,
        };
      }
    );
    builder.addCase(
      getAppVersionAction.rejected,
      (state: AppVersionType, { error }) => {
        return {
          ...state,
          fetching: false,
          error: error.message ?? null,
        };
      }
    );
  },
});

export const { resetStatusInfo, resetAppVersionSlice } =
  appVersionSlice.actions;
